<template>
  <v-dialog :value="open" persistent width="60rem">
    <v-card>
      <v-card-title>
        <div>Search</div>
        <v-spacer></v-spacer>
        <v-btn small icon @click="handleCloseButtonClick">
          <v-icon small>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>

      <v-card-text>
        <v-container fluid grid-list-lg :style="{ width: '100% !important' }">
          <v-layout wrap>
            <v-flex xs12>
              <div class="caption">{{ $t('channel') }}</div>
              <v-radio-group v-model="localValue.channel" row hide-details>
                <v-radio
                  v-for="option in channelOptions"
                  :key="option.value"
                  :label="option.text"
                  :value="option.value"
                  color="primary"
                ></v-radio>
              </v-radio-group>
            </v-flex>
            <v-flex class="default-input" xs12 md6>
              <div class="caption">{{ $t('start_date') }}</div>
              <DatePickerWithoutButton
                v-model="localValue.startTime"
                v-validate="'required'"
                :max="currentDate"
                :min="lastYearDate"
                name="start_time"
                data-vv-as="Start date"
              >
                <v-text-field
                  :value="localValue.startTime"
                  single-line
                  outline
                  hide-details
                  class="custom-datepicker-input"
                  readonly
                  :error="errors.has('start_time')"
                  :error-messages="errors.first('start_time')"
                ></v-text-field>
              </DatePickerWithoutButton>
            </v-flex>
            <v-flex class="default-input" xs12 md6>
              <div class="caption">{{ $t('end_date') }}</div>
              <DatePickerWithoutButton
                v-model="localValue.endTime"
                v-validate="'required'"
                :min="localValue.startTime"
                :max="currentDate"
                name="end_time"
                data-vv-as="End date"
              >
                <v-text-field
                  :value="localValue.endTime"
                  single-line
                  outline
                  hide-details
                  readonly
                  class="custom-datepicker-input"
                  :error="errors.has('end_time')"
                  :error-messages="errors.first('end_time')"
                ></v-text-field>
              </DatePickerWithoutButton>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="handleClearSearchButtonClick">
          <v-icon>clear</v-icon>
          Clear search
        </v-btn>
        <v-btn color="primary" @click="handleSearchButtonClick">
          <v-icon>search</v-icon>
          Search
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import DatePickerWithoutButton from '@/components/elements/DatePickerWithoutButton.vue'
import moment from 'moment'

export default {
  components: {
    DatePickerWithoutButton
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    open: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentDate: moment().format('YYYY-MM-DD'),
      lastYearDate: moment().subtract(1, 'year').format('YYYY-MM-DD'),
      localValue: {
        search_page_id: '',

        startTime: '',
        endTime: '',

        ...this.value,
        channel: this.value && this.value.channel ? this.value.channel : ''
      },
      pageOptions: [
        { value: '', text: this.$t('all') },
        ...this.$store.state.botlist.map((item) => ({ value: item.pageid, text: item.pagename }))
      ]
    }
  },
  computed: {
    channelOptions: function () {
      return [
        { value: '', text: this.$t('all') },
        ...this.conversationSocialChannelOptions.map((item) => ({
          value: item.fullValueForUse,
          text: item.text
        }))
      ]
    }
  },
  watch: {
    value(value) {
      this.localValue = { ...value }
    },
    'localValue.startTime': function (newVal, oldVal) {
      if (newVal != oldVal) {
        // start date more than end date
        if (moment(newVal).isAfter(this.localValue.endTime)) {
          this.localValue.endTime = newVal
        }
      }
    }
  },
  methods: {
    handleCloseButtonClick() {
      this.$emit('update:open', false)
    },
    async handleSearchButtonClick() {
      await this.$validator.validateAll()
      if (this.errors.any()) {
        this.goToErrorInput()
        return
      }
      this.$emit('input', { ...this.localValue })
      this.$emit('update:open', false)
    },
    handleClearSearchButtonClick() {
      this.$emit('input', {
        search_page_id: '',
        channel: '',
        startTime: moment().format('YYYY-MM-DD'),
        endTime: moment().format('YYYY-MM-DD')
      })
      this.$emit('update:open', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/ticket3/agent-management/overview/StatisticsSearchDialog.vue